import {
  Container,
  styled,
  Box,
} from "@mui/material";
import FigmaModal from "components/modal/FigmaModal";
import { useNavigate } from 'react-router-dom';

const ViewUserAgreementPage = () => {
    const navigate = useNavigate();

    const onClose = () => {
        navigate('/landing');
    }

    return (
        <StyledContainer>
            <Box>
                <FigmaModal type="userAgreement" open={true} onClose={onClose} ></FigmaModal>
            </Box>
        </StyledContainer>
    );
};

export default ViewUserAgreementPage;

const StyledContainer = styled(Container)({
  marginBottom: 24,
});